/**
 * Портальное контекстное меню feature карты (Wave 1.4).
 * Controlled: MapLibre отдаёт координаты курсора и id объекта.
 */

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface MapFeatureContextTarget {
  objectId: number;
  geometryId?: number | null;
  label?: string | null;
  clientX: number;
  clientY: number;
}

interface MapFeatureContextMenuProps {
  target: MapFeatureContextTarget | null;
  onOpenChange: (open: boolean) => void;
  onSelect: () => void;
  onOpenDetails: () => void;
  onZoomTo: () => void;
  onAddToMultiSelect: () => void;
}

export default function MapFeatureContextMenu({
  target,
  onOpenChange,
  onSelect,
  onOpenDetails,
  onZoomTo,
  onAddToMultiSelect,
}: MapFeatureContextMenuProps) {
  const open = target != null;

  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      {/* Невидимый якорь в точке курсора — Radix позиционирует Content от Trigger. */}
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-hidden
          tabIndex={-1}
          className="fixed h-0 w-0 opacity-0 pointer-events-none"
          style={
            target
              ? { left: target.clientX, top: target.clientY }
              : { left: 0, top: 0 }
          }
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="z-[250] w-52"
        align="start"
        side="bottom"
        sideOffset={4}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DropdownMenuLabel className="truncate text-xs font-normal text-muted-foreground">
          {target?.label?.trim() || `Объект #${target?.objectId ?? ""}`}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onSelect}>Выбрать</DropdownMenuItem>
        <DropdownMenuItem onSelect={onOpenDetails}>Открыть детали</DropdownMenuItem>
        <DropdownMenuItem onSelect={onZoomTo}>Приблизить</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onAddToMultiSelect}>Добавить в multi-select</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
